// src/router/index.js
import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";

// 引入页面组件
// import HomePage from "@/views/homeNew/index.vue";
import PageIndex from "@/views/page/list.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/home",
      component: Layout,
      children: [
        {
          path: "home",
          name: "Home",
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "list",
          name: "List",
          component: () => import("@/views/list/index.vue"),
        },
        {
          path: "search",
          name: "Search",
          component: () => import("@/views/list/search.vue"),
        },
        {
          path: "detail",
          name: "Detail",
          component: () => import("@/views/detail/index.vue"),
        },
      ],
    },
    {
      path: "/read",
      name: "Read",
      component: () => import("@/views/home/read.vue"),
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
// router.beforeEach((to, from, next) => {
//   const meetingId = to.query.meetingId;
//   if (meetingId) {
//     return next();
//   }
//   if (to.path === "/") {
//     return next();
//   }

//   return next({ path: "/", query: { meetingId: "" } });
// });

export default router;
